import { memo } from 'react'
import { Tooltip } from '@highlight/ui'
import { useMessageListScrollActions, useMessageListScrollFlags } from './message-list/scroll-atoms'
import { AnimatePresence, motion } from 'framer-motion'
import { cn } from '../../utils'
import { useGlobalStore } from '@highlight/ipc/react'
import { isAssistant } from '../../utils/runtimeUtils'

export const ScrollToEnd = memo(() => {
  const { showScrollToEnd } = useMessageListScrollFlags()
  const { scrollToEnd } = useMessageListScrollActions()
  const [sidePanelOpen] = useGlobalStore<boolean>('chat', 'side-panel-open', false)

  const isMac = process.platform === 'darwin'

  return (
    <AnimatePresence>
      {showScrollToEnd && (
        <motion.div
          {...animation}
          className={cn(
            'absolute bottom-[calc(100%+14px)] z-10',
            sidePanelOpen && !isAssistant ? 'right-10' : 'right-3',
          )}
        >
          <Tooltip>
            <Tooltip.Trigger
              render={
                <button
                  type="button"
                  aria-label="Scroll to end"
                  onClick={(e) => {
                    e.stopPropagation()
                    scrollToEnd()
                  }}
                  className="text-foreground-secondary hover:text-foreground hover:bg-background-subtle bg-background/95 flex cursor-pointer items-center gap-1 rounded-full py-1.5 pl-3 pr-3 text-xs shadow-lg transition-all"
                >
                  <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              }
            />
            <Tooltip.Content>
              Scroll to bottom
              <Tooltip.Hotkey hotkey={isMac ? 'cmd+down' : 'ctrl+down'} />
            </Tooltip.Content>
          </Tooltip>
        </motion.div>
      )}
    </AnimatePresence>
  )
})

const animation = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 20,
  },
  transition: {
    type: 'spring',
    stiffness: 300,
    damping: 25,
  },
}
